module.exports = __webpack_public_path__ + "static/media/bg_bomba.fa8f1515.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/bg/bg_bomba.png
// module id = 1255
// module chunks = 0